import { useState } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { saveAs } from "file-saver";
import {
  getPackingGdn,
  completePackingGdn,
  openSpeditorModal,
  downloadGdnControlLabel,
  deletePackage,
} from "actions/pack_gdn";
import { api_url_v2 } from "utils/api";

import SpeditorModal from "./components/SpeditorModal";
import { ModalDelete } from "expano-components";

const ConfirmPanel = ({
  getPackingGdn,
  disabled_delivery_methods,
  completePackingGdn,
  data,
  history,
  is_open_speditor_modal,
  openSpeditorModal,
}) => {
  const [delete_package_data, setDeletePackageData] = useState(null);
  const [assign_package_id, setAssignPackageId] = useState(null);

  if (!["packed", "completed"].includes(data.status)) {
    return null;
  }

  const is_completed = data.status === "completed";

  const has_packages = data?.packages?.length > 0;

  const handleConfirm = async () => {
    try {
      const {
        packages_need_verification,
        packages_with_wrong_cod,
        validation_result,
        packages_dimensions,
      } = await completePackingGdn(data.id);

      if (packages_with_wrong_cod || packages_need_verification) {
        downloadGdnControlLabel({
          expano_oms_id: data.expano_oms_id,
          id: data.id,
          validation_result,
          packages_count: data.packages.length,
          packages_dimensions,
          packages_with_wrong_cod,
        });
      } else {
        history.push(`/packing/gdn_pack/${data.gdn_pack.id}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    try {
      await deletePackage(delete_package_data.id);
      setDeletePackageData(null);
      getPackingGdn({
        id: data.id,
        shuffle_colors: false,
      });
    } catch (error) {
      throw error;
    }
  };

  const can_confirm =
    ([
      "Allegro Odbiór w Punkcie Packeta",
      "Allegro Automaty Paczkowe Packeta",
    ].includes(data?.delivery_method_name) &&
      data.cod) ||
    has_packages;

  const is_delivery_method_disabled = disabled_delivery_methods.includes(
    data.delivery_method_name,
  );

  const can_remove_packages =
    data.status === "packed" &&
    data?.delivery_method_name !== "Allegro Paczkomaty InPost";

  return (
    <>
      {delete_package_data?.id && (
        <ModalDelete
          handleDelete={handleDelete}
          handleClose={() => setDeletePackageData(null)}
          name={`etykietę ${delete_package_data?.courier_number}?`}
        />
      )}
      <div
        className={classNames("confirm-panel", {
          is_completed,
        })}
      >
        {is_completed && (
          <div className="confirm-panel__info">
            <p className="title">Zamówienie zrealizowane</p>
          </div>
        )}
        {!is_completed && (
          <>
            <button
              disabled={is_delivery_method_disabled}
              className="confirm-panel__create-label"
              onClick={() => openSpeditorModal(true)}
            >
              {is_delivery_method_disabled ? (
                <span className="sm">
                  Tymczasowo zablokowana możliwość nadawania paczek dla{" "}
                  {data.delivery_method_name}.
                  <br /> Zgłoś problem z zamówieniem podając{" "}
                  <strong>wymiary paczki</strong>.
                </span>
              ) : (
                <span>Nadaj {has_packages ? "kolejną" : ""} paczkę</span>
              )}
            </button>
            <button
              disabled={!can_confirm}
              className="confirm-panel__confirm"
              onClick={handleConfirm}
            >
              <span>Potwierdź zamówienie</span>
            </button>
          </>
        )}
        {is_open_speditor_modal && (
          <SpeditorModal handleClose={() => openSpeditorModal(false)} />
        )}
        {assign_package_id && (
          <SpeditorModal
            handleClose={() => setAssignPackageId(null)}
            package_id={assign_package_id}
          />
        )}
      </div>
      {data?.packages?.length > 0 && (
        <ul className="confirm-panel__labels">
          {data.packages
            .filter(({ is_ghost }) => !is_ghost)
            .map(
              ({ courier_number, id, is_created_manually, package_boxes }) => (
                <li key={id}>
                  <div className="box-name">
                    <p>{courier_number}</p>
                  </div>

                  <div className="box-packages">
                    {package_boxes.length > 0 && <p>Podpaczki:</p>}
                    <ul>
                      {package_boxes.map(
                        ({
                          id,
                          size,
                          width,
                          height,
                          depth,
                          weight,
                          gauge_weight,
                        }) => (
                          <li key={id}>
                            {size} ({width}x{height}x{depth}
                            ) <br />
                            w: {weight} kg | wg.: {gauge_weight || "-"} kg
                          </li>
                        ),
                      )}
                    </ul>
                  </div>
                  {can_remove_packages && !is_created_manually && (
                    <button
                      type="button"
                      className="btn-danger"
                      onClick={() =>
                        setDeletePackageData({ id, courier_number })
                      }
                    >
                      <span>Usuń</span>
                    </button>
                  )}
                  {is_created_manually ? (
                    <>
                      {package_boxes.length > 0 ? (
                        <button
                          type="button"
                          onClick={() => {
                            saveAs(
                              `${api_url_v2}packages/${id}/download_label`,
                              `${courier_number}.pdf`,
                            );
                          }}
                        >
                          <span>Pobierz etykietę</span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => setAssignPackageId(id)}
                        >
                          <span>Dodaj podpaczki</span>
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      type="button"
                      onClick={() => {
                        saveAs(
                          `${api_url_v2}packages/${id}/download_label`,
                          `${courier_number}.pdf`,
                        );
                      }}
                    >
                      <span>Pobierz etykietę</span>
                    </button>
                  )}
                </li>
              ),
            )}
        </ul>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getPackingGdn: (data) => dispatch(getPackingGdn(data)),
  completePackingGdn: (id) => dispatch(completePackingGdn(id)),
  openSpeditorModal: (is_open) => dispatch(openSpeditorModal(is_open)),
});

export default connect(
  ({ current_user, pack_gdn: { data, is_open_speditor_modal } }) => ({
    data,
    is_open_speditor_modal,
    disabled_delivery_methods:
      current_user?.company?.disabled_delivery_methods || [],
  }),
  mapDispatchToProps,
)(withRouter(ConfirmPanel));
